import { apiClient } from "@/lib/api/client";

export type ExpenseListItemDto = {
  id: string;
  ticket_id: string;
  ticket_subject: string;
  tenant_id: string;
  device_id: string | null;
  device_name: string | null;
  category_id: string;
  category_name: string;
  expense_date: string;
  amount: string;
  currency: string;
  purpose: string;
  vendor: string | null;
  payment_method: string | null;
  reference_number: string | null;
  tax_amount: string | null;
  is_reimbursable: boolean;
  incurred_by_user_id: string;
  incurred_by_name: string | null;
  status: "posted" | "void";
  created_at: string;
};

export type ExpenseListResponseDto = {
  items: ExpenseListItemDto[];
  total: number;
  limit: number;
  offset: number;
  summary: { total: number; posted_total: string; void_total: string; reimbursable_total: string };
  category_breakdown: Array<{ category_name: string; posted_total: string; count: number }>;
};

export type ExpenseListParams = {
  tenantId?: string | null;
  startDate?: string;
  endDate?: string;
  categoryId?: string;
  status?: "posted" | "void";
  paymentMethod?: string;
  reimbursable?: boolean;
  search?: string;
  deviceSearch?: string;
  ticketSearch?: string;
  incurredBySearch?: string;
  limit?: number;
  offset?: number;
};

function requestParams(params: ExpenseListParams): Record<string, string | number | boolean> {
  const query: Record<string, string | number | boolean> = {};
  if (params.tenantId) query.tenant_id = params.tenantId;
  if (params.startDate) query.start_date = params.startDate;
  if (params.endDate) query.end_date = params.endDate;
  if (params.categoryId) query.category_id = params.categoryId;
  if (params.status) query.status = params.status;
  if (params.paymentMethod) query.payment_method = params.paymentMethod;
  if (typeof params.reimbursable === "boolean") query.reimbursable = params.reimbursable;
  if (params.search?.trim()) query.search = params.search.trim();
  if (params.deviceSearch?.trim()) query.device_search = params.deviceSearch.trim();
  if (params.ticketSearch?.trim()) query.ticket_search = params.ticketSearch.trim();
  if (params.incurredBySearch?.trim()) query.incurred_by_search = params.incurredBySearch.trim();
  if (typeof params.limit === "number") query.limit = params.limit;
  if (typeof params.offset === "number") query.offset = params.offset;
  return query;
}

export async function listExpenses(params: ExpenseListParams): Promise<ExpenseListResponseDto> {
  const { data } = await apiClient.get<ExpenseListResponseDto>("/expenses", { params: requestParams(params) });
  return data;
}

export async function listExpenseFilterCategories(): Promise<Array<{ id: string; name: string }>> {
  const { data } = await apiClient.get<Array<{ id: string; name: string }>>("/expenses/categories");
  return data;
}

export async function exportExpenses(params: ExpenseListParams, format: "csv" | "xlsx"): Promise<Blob> {
  const { data } = await apiClient.get<Blob>("/expenses/export", { params: { ...requestParams(params), format }, responseType: "blob" });
  return data;
}
